<template>
  <div class="lesson-collection">
    <el-collapse v-model="activeColl" accordion>
      <el-collapse-item v-for="(item, key) in collection" :key="key" :name="key">
        <template v-slot:title>
          <span class="header-coll">{{normailCollectionItemName(item)}}<img src="/assets/vip.png" width="16px" style="margin-left: 5px;position: relative;top: 3px;" v-if="item.free===0"></span>
          <i class="header-icon hover-main el-icon-menu" title="更换显示方式" @click.stop="handleCollTheme(item, key)"></i>
          <i class="header-icon hover-main el-icon-attract" title="重置时长和经验值" @click.stop="handleRefresh(item, key)"></i>
          <i class="header-icon hover-main el-icon-edit" title="修改小节" @click.stop="handleEditColl(item, key)"></i>
          <i class="header-icon hover-main el-icon-delete" title="删除小节" @click.stop="handleDeleteColl(item, key)"></i>
        </template>
        <div class="operations" v-if="selection[item.id]">
          <el-button-group>
            <el-button type="primary" icon="el-icon-plus" @click="handleBatchAll(item.id, $event)">全选</el-button>
            <el-button type="primary" icon="el-icon-delete" @click="handleBatchDelete(item.id, $event)">删除</el-button>
            <el-button type="primary" icon="el-icon-edit" @click="handleBatchUpdate(item.id, $event)">设置</el-button>
            <el-button type="primary" icon="el-icon-back" @click="handleBatchCancel(item.id, $event)">取消</el-button>
          </el-button-group>
        </div>
        <draggable v-model="item.entities" draggable=".lesson-entity" @start="handleDargStart" @end="handleDargEnd(key)" :class="['lesson-entities', 'theme-' + item.theme]">
          <LessonEntity 
          v-for="(entity, eKey) in item.entities" 
          :key="eKey" 
          :entity="entity" 
          :class="['entity-' + entity.entity_type, {'actived' : entity.entity_type === 'exercise' && entity.exercise_entity.tid == exrtype, 'action-hover': hoverActionLink[entity.id]} ]"
          :theme="item.theme">
          <template v-slot:header>
            <el-row type="flex" class="entity-header">
              <el-col :span="6">
                <el-checkbox :ref="'sels' + item.id" :true-label="item.id + '-' + entity.id" @change="handleSelection">{{eKey+1}}</el-checkbox>
                <span v-show="entity.entity_id">#{{entity.entity_id}}</span>
              </el-col>
              <el-col class="text-right exp-info" :span="18">
                <span v-show="/exercise|^iq_/.test(entity.entity_type)">
                  Exp: {{entity.exp}}&nbsp; YB: {{entity.coin}} x {{entity.coinx}}
                </span>
                <span class="tools">
                  <i class="el-icon-edit" @click="handleEditEntityTarget(entity)" v-if="/word|grammar|kewen|exercise/.test(entity.entity_type)"></i>
                  <i class="el-icon-setting" @click="handleEditEntity(entity)"></i>
                </span>
              </el-col>
            </el-row>
          </template>
          <template #footer>
            <div class="entity-action text-warning" v-if="entity.entity_data && entity.entity_data.action">
              <div v-for="(act, actKey) in entity.entity_data.action" :key="actKey" @mouseenter="handleEntityActionEnter(act, item, eKey)" @mouseleave="handleEntityActionLeave(act)">
                <div>
                  题<span>{{getEntityActionSourceString(item, act)}}</span>答对<span>{{act.rights}}</span>题, 前进<span>{{act.next}}</span>页
                </div>
              </div>
            </div>
          </template>
          </LessonEntity>
        </draggable>
        <div class="add-entity-item text-center" style="margin-top:30px;">
          <el-button type="text" icon="el-icon-plus" @click="openSelect=!openSelect">添加项目</el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
    <LessonEntitySelect v-model="openSelect" direction="right" @select="handleSelect"></LessonEntitySelect>
    <el-row type="flex" justify="left" style="margin-top:12px;">
      <el-button type="text" icon="el-icon-plus" @click="handleAddColl">添加小节</el-button>
    </el-row>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" :class="dialogComponent">
      <component :is="dialogComponent" ref="modal" :lid="lid" :unid="unid"></component>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import collForm from './LessonCollItem'
import LessonEntity from './LessonEntity'
import LessonEntitySelect from './LessonEntitySelect'
import LessonEntityForm from './LessonEntityForm'
import qs from 'qs'
import draggable from 'vuedraggable'
import utils from '@/js/utils'
import LessonTargetForm from './LessonTargetForm'

export default {
  name: 'LessonCollection',
  props: {
    lid: Number,
    unid: Number,
    unit: Object,
    exrtype: Number
  },
  components: { collForm, LessonEntity, LessonEntitySelect, LessonEntityForm, draggable, LessonTargetForm },
  data () {
    return {
      drag: false,
      activeColl: 0,
      collection: [],
      dialogTitle: '',
      dialogVisible: false,
      dialogComponent: null,
      openSelect: false,
      selection: {},
      hoverActionLink: {},
    }
  },
  watch: {
    unid: {
      handler (newVal, oldVal) {
        if (this.unid) {
          this.fetchData()
        }
      },
      immediate: true
    }
  },
  methods: {
    fetchData () {
      return this.$http.get(this.$urls.lesson_coll_list, {
        params: {
          'filter[unid]': this.unid,
          'filter[status]': 1,
          page: 1,
          'per-page': 100
        }
      }).then(res => {
        this.collection = this.initCollectionData(res.data || [])
        this.updateStateKnows()
      })
    },
    handleAddColl () {
      this.openForm('添加小节', 'collForm', {})
    },
    handleEditColl (item) {
      this.openForm('编辑小节', 'collForm', {
        id: item.id,
        type: item.type,
        title: item.title,
        intro: item.intro,
        duration: item.duration,
        free: item.free,
        status: item.status
      })
    },
    handleDeleteColl (item) {
      this.$confirm('此操作将删除该小节下的所有内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.put(this.$urls.lesson_coll_update, {status: 0}, {
          params: { id: item.id }
        }).then(res => {
          this.reloadNumbers(item, {
            exp: 0,
            duration: 0,
            count: 0,
            exr_count: 0
          })
          this.fetchData()
        })
      })
    },
    handleCollTheme (item) {
      if (item.theme === 'card') {
        item.theme = 'line'
      } else {
        item.theme = 'card'
      }
    },
    openForm (title, name, item) {
      this.dialogVisible = true
      this.dialogTitle = title
      if (this.dialogComponent !== name) {
        this.dialogComponent = name
      }
      setTimeout(() => {
        item && this.$refs.modal.reset(item)
      }, 1)
    },
    submitForm () {
      this.$refs.modal.submit().then(res => {
        this.dialogVisible = false
        if (this.dialogComponent === 'collForm') {
          this.submitCollForm(this.$refs.modal.form)
        } else if (this.dialogComponent === 'LessonEntityForm') {
          this.submitBatchForm(res)
        } else {
          this.fetchData()
        }
        this.$refs.modal.reset()
      })
    },
    submitCollForm (fd) {
      let item = this.collection.find(n => n.id === fd.id)
      if (item) {
        let addDur = fd.duration - item.duration
        if (this.unit && addDur !== 0) {
          this.unit.duration += addDur
        }
        Object.assign(item, fd)
        this.initCollectionItem(item)
      } else {
        item = JSON.parse(JSON.stringify(fd))
        this.initCollectionItem(item)
        this.collection.push(item)
        this.activeColl = this.collection.length - 1
      }
    },
    submitBatchForm (res) {
      this.handleBatchCancel(this.$refs.modal.cid)
      this.fetchData()
    },
    handleSelect (model) {
      let coll = this.collection[this.activeColl]
      if (coll.id) {
        model.coll_id = coll.id
      } else {
        model.collection = { ...coll, unid: this.unid }
      }
      model.unid = this.unid
      model.weight = coll.entities.length > 0 ? Number.parseInt(coll.entities[coll.entities.length - 1].weight) + 1 : 0
      let params = qs.stringify(model)
      return this.$http.post(this.$urls.lesson_entity_create, params).then(res => {
        coll.entities.push(res.data)
        this.updateStateKnows()
        this.reloadNumbers(coll)
      })
    },
    normailCollectionItemName(item) {
      let name = this.getCollectionItemName(item)
      let duration = utils.asDuration(item.duration * 1000)
      return `${name} (时长: ${duration}  经验值: ${item.exp})`
    },
    getCollectionItemName (item) {
      if (item.title) {
        return item.title
      } else if (item.type === 'words') {
        return '生字'
      } else if (item.type === 'text') {
        return '课文'
      } else if (item.type === 'grammar') {
        return '语法'
      } else if (item.type === 'test') {
        return '小测试'
      }
      return item.title
    },
    initCollectionItem (item) {
      if (item.entities === undefined) {
        item.entities = []
      }
      if (item.theme === undefined) {
        item.theme = 'line'
      }
    },
    initCollectionData (res) {
      res.forEach(this.initCollectionItem)
      return res
    },
    handleSelection (checked, event) {
      let [cid, eid] = event.target.getAttribute('true-value').split('-').map(n => Number.parseInt(n))
      if (checked === false) {
        if (this.selection[cid]) {
          let i = this.selection[cid].indexOf(eid)
          if (i >= 0) {
            this.selection[cid].splice(i, 1)
            if (this.selection[cid].length === 0) {
              this.$delete(this.selection, cid)
            }
          }
        }
      } else if (!this.selection[cid]) {
        this.$set(this.selection, cid, [eid])
      } else {
        this.selection[cid].push(eid)
      }
    },
    handleBatchAll (cid) {
      let k = 'sels' + cid
      let values = []
      this.$refs[k].forEach(el => {
        if (!el.isChecked) el.model = el.trueLabel
        values.push(Number.parseInt(el.trueLabel.split('-')[1]))
      })
      this.$set(this.selection, cid, values)
    },
    handleBatchDelete (cid) {
      if (!this.selection[cid]) {
        return
      }
      this.$confirm('此操作将删除所有选中的内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let coll = this.collection.find(col => col.id === cid)
        let params = { 
          ids: this.selection[cid],
          unid: coll.unid,
          coll_id: coll.id
        }
        this.$http.post(this.$urls.lesson_entity_batchdelete, qs.stringify(params)).then(res => {
          coll.entities = coll.entities.filter(n => this.selection[cid].indexOf(n.id) === -1)
          this.$delete(this.selection, cid)
          this.updateStateKnows()
          this.reloadNumbers(coll)
        })
      })
    },
    handleBatchUpdate (cid) {
      let coll = this.collection.find(col => col.id === cid)
      this.openForm('批量修改内容', 'LessonEntityForm', {
        cid: cid,
        unid: coll.unid,
        ids: this.selection[cid]
      })
    },
    handleBatchCancel (cid) {
      let k = 'sels' + cid
      this.$refs[k].forEach(el => {
        if (el.isChecked) el.model = false
      })
      this.$delete(this.selection, cid)
    },
    handleRefresh(item) {
      this.$confirm('确定要重置当前小节的时长和经验值吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(this.$urls.lesson_coll_refresh, {coll_id: item.id}).then(res => {
          this.reloadModel(item, res.data)
        })
      })
    },
    handleEditEntity (entity) {
      this.openForm('设置', 'LessonEntityForm', {
        cid: entity.coll_id,
        form: entity,
        ids: null
      })
    },
    handleEditEntityTarget(entity){
      this.openForm('更新', LessonTargetForm, entity)
    },
    updateStateKnows () {
      let items = []
      this.collection.forEach((coll, index) => {
        if (coll.entities) {
          let options = [];
          coll.entities.forEach(n => {
            if (n.entity_type !== 'exercise') {
              let entity = n[n.entity_type + '_entity']
              if (entity) {
                options.push({
                  id: n.entity_id,
                  type: n.entity_type,
                  key: n.entity_type + ':' + n.entity_id,
                  name: entity.text || entity.title || entity.name
                })
              }
            }
          })
          if (options.length > 0) {
            items.push({
              name: this.getCollectionItemName(coll),
              options: options,
            })
          }
        }
      })
      if (items.length > 0) {
        this.$store.commit('updateKnows', {id: this.lid, items})
      }
    },
    handleDargStart () {
      this.drag = true
    },
    handleDargEnd (index) {
      this.drag = false
      let items = this.collection[index].entities.map((n, i) => {
        return {
          id: n.id,
          weight: i,
          oldWeight: n.weight
        }
      }).filter(n => n.weight !== n.oldWeight)
      let params = {
        unid: this.collection[index].unid,
        coll_id: this.collection[index].id,
        items
      }
      items.length > 0 && this.$http.post(this.$urls.lesson_entity_sort, qs.stringify(params)).then(res => {
        this.collection[index].entities.forEach((n, i) => {
          if (n.weight !== i) n.weight = i
        })
        this.$message({
          type: 'success',
          message: '修改排序数据成功!',
          duration: 2000
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '修改排序数据失败!',
          duration: 2000
        })
      })
    },
    reloadNumbers(coll) {
      this.$http.get(this.$urls.lesson_coll_view, {params: {id: coll.id}}).then(res => {
        this.reloadModel(coll, res.data)
      })
    },
    reloadModel(coll, data) {
      this.unit.exp += data.exp - coll.exp
      this.unit.duration += data.duration - coll.duration
      this.unit.count += data.count - coll.count
      this.unit.exr_count += data.exr_count - coll.exr_count
      coll.exp = data.exp
      coll.duration = data.duration
      coll.count = data.count
      coll.exr_count = data.exr_count
    },
    getEntityActionSourceString(item, action) {
      return action.source.map(id => {
        return item.entities.findIndex(n => n.id == id) + 1
      }).join('、')
    },
    handleEntityActionEnter(action, item, index) {
      index += action.next
      if (index < item.entities.length) {
        let link = {}
        action.source.concat(item.entities[index].id).forEach(n => {
          link[n] = true
        })
        this.hoverActionLink = link
      }
    },
    handleEntityActionLeave(action) {
      this.hoverActionLink = {}
    }
  },
  destroyed () {
    this.$store.commit('clearKnows')
  }
}
</script>

<style lang="scss">
  .lesson-entities{
    margin: -5px;
    > div{
      margin: 5px;
      border: 1px solid #eee;
      padding: 5px 8px;
      background-color: white;
      transition: all .15s;
      &.lesson-entity{
        border-color: #409EFF;
        border-width: 2px;
      }
      &.entity-exercise{
        border-color: #eee;
        border-width: 1px;
      }
      &:nth-child(even){
        background-color: #fafafa;
      }
      &:hover{
        background-color: #f5f7fa;
      }
      &[draggable=true] {
        border-color: #409EFF;
        background-color: rgba(#409EFF, .5)
      }
    }
  }
  .lesson-entities.theme-card{
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    margin: -10px;
    > div {
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;
      width: 375px;
      margin: 10px;
      >div:last-child{
        display: flex;
        flex-direction: column;
        flex: 1;
      }
    }
    .word-preview,
    .exr-content{
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      justify-content: space-evenly;
      > div{
        margin-top: 12px;
        margin-bottom: 12px;
      }
      img{
        max-width: 100%;
      }
    }
    .word-preview{
      > img{
        max-width: 200px;
        margin-top: 12px;
      }
    }
    .exr-content{
      .items {
        margin-left: -8px;
        margin-right: -8px;
        > div{
          margin-left: 8px;
          margin-right: 8px;
          max-width: 170px;
        }
      }
    }
  }
  
  .el-collapse-item__header{
    font-weight: bold;
    font-size: 14px;
  }
  .arrow-down{
    text-align: center;
    cursor: pointer;
    border-style: dotted !important;
    border-width: 2px !important;
    color: #409EFF;
    border-color: #409EFF !important;
    > i{
      padding: 0 10px;
      font-size:32px;
    }
  }
  .lesson-collection{
    .operations{
      margin-bottom: 12px;
    }
    .header-icon{
      margin: 5px;
    }
    .header-coll{
      flex: 1;
    }
    .tools{
      font-size: 16px;
      > i{
        padding: 0 3px;
        cursor: pointer;
        &:hover{
          color: #409EFF;
        }
      }
    }
  }
  .entity-select-bottom .lesson-collection{
    padding-bottom: 50vh;
    margin-bottom: 20px;
  }
  .entity-select-right .lesson-collection{
    padding-right: 50vw;
    margin-right: 20px;
    @media (min-width:1600px) {
      padding-right: 800px;
    }
  }
  .LessonEntityForm >.el-dialog{
    max-width: 600px;
  }
  .entity-exercise.actived{
    background-color: #f1d9b4 !important;
  }
  .entity-action{
    > div {
      display: inline-block;
      > div {
        display: inline-block;
        cursor: pointer;
        border-bottom: 1px solid transparent;
      }
      &:hover > div{
        border-bottom-color: #E6A23C;
      }
      &::before {
        content: '|';
        padding: 0 10px;
      }
      &:first-child::before{
        display: none;
      }
      span {
        padding: 0 5px;
        font-weight: bold;
      }
    }
  }
  .action-hover{
    border-color: #E6A23C !important;
  }
</style>
